module.exports = __webpack_public_path__ + "static/img/4.356e317.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/list/4.png
// module id = 5QOT
// module chunks = 1